import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Switch} from 'antd'

import style from './assetType.sass'

@inject('store') @observer
class AssetType extends Component {
  changeAssetType = (value) => {
    this.props.store.analysis.change('has_coins', value)
  }
  render() {
    const {has_coins} = this.props.store.analysis
    return(
      <div styleName='wrapper'>
        <span styleName={!has_coins ? 'active' : ''}>Stocks</span>
        <Switch
          name='has_coins'
          onChange={this.changeAssetType}
        />
        <span styleName={has_coins ? 'active' : ''}>Crypto</span>
      </div>
    )
  }
}

export default AssetType
